var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeTicketWrite = function SvgScopeTicketWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M5.333 5.333v-.666m0 3.666v-.666m0 3.666v-.666M14.667 7V5.867c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218H4.533c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v4.266c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218H6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.117 13.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 1 1 1.24 1.242l-4.099 4.1c-.091.09-.137.136-.19.171a.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L8 15z"
  })));
};
export default SvgScopeTicketWrite;